import { FC, useMemo } from 'react'
import Tabs, { TabsProps } from 'src/components/Tabs'

import Blocks from '..'
import { BlockProps } from '../props'

import { BlockTabProps } from './props'

const BlockTab: FC<BlockProps<BlockTabProps>> = ({
  data,
  locale,
  configuration,
}) => {
  const props: TabsProps = useMemo(
    () => ({
      title: data.title || '',
      // v4: `tabs.data[].attributes`; v5: flat array.
      tabs: ((data?.tabs as any)?.data ?? data?.tabs ?? []).map(
        (tabRaw: any) => {
          const attrs: any = tabRaw?.attributes ?? tabRaw
          return {
            title: attrs?.title || '',
            content: (
              <Blocks
                blocks={attrs?.blocks || []}
                locale={locale}
                configuration={configuration}
              />
            ),
          }
        }
      ),
    }),
    [configuration, data, locale]
  )

  return <Tabs {...props} />
}

export default BlockTab
